import { gettext } from '@eventbrite/i18n';
import {
    AUTO_BOAT_AIR_EVENTBRITE_CATEGORY,
    BUSINESS_EVENTBRITE_CATEGORY,
    CHARITY_EVENTBRITE_CATEGORY,
    COMMUNITY_EVENTBRITE_CATEGORY,
    EVENTBRITE_CATEGORY_DISPLAY_MAPPING,
    FAMILY_EDUCATION_EVENTBRITE_CATEGORY,
    FASHION_EVENTBRITE_CATEGORY,
    FILM_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    HOME_LIFESTYLE_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    OTHER_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    POLITICS_EVENTBRITE_CATEGORY,
    RELIGION_EVENTBRITE_CATEGORY,
    SCHOOL_EVENTBRITE_CATEGORY,
    SCIENCE_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
    TRAVEL_EVENTBRITE_CATEGORY,
} from './categories';

const THINGS_TO_DO_MUSIC_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[MUSIC_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/fa779a/django/images/things_to_do/ways-to-tour/music.webp',
    key: MUSIC_EVENTBRITE_CATEGORY,
    slug: 'music',
};

const THINGS_TO_DO_BUSINESS_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[BUSINESS_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/36c62d/django/images/things_to_do/ways-to-tour/business.webp',
    key: BUSINESS_EVENTBRITE_CATEGORY,
    slug: 'business',
};

const THINGS_TO_DO_PERFORMING_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[PERFORMING_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/1e5516/django/images/things_to_do/ways-to-tour/arts.webp',
    key: PERFORMING_EVENTBRITE_CATEGORY,
    slug: 'arts',
};

const THINGS_TO_DO_FILM_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[FILM_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/b2434a/django/images/things_to_do/ways-to-tour/film_and_media.webp',
    key: FILM_EVENTBRITE_CATEGORY,
    slug: 'film-and-media',
};

const THINGS_TO_DO_SPORTS_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[SPORTS_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/225835/django/images/things_to_do/ways-to-tour/sports.webp',
    key: SPORTS_EVENTBRITE_CATEGORY,
    slug: 'sports-and-fitness',
};

const THINGS_TO_DO_FOOD_AND_DRINK_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[
        FOOD_AND_DRINK_EVENTBRITE_CATEGORY
    ],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/7a418d/django/images/things_to_do/ways-to-tour/food_and_drink.webp',
    key: FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    slug: 'food-and-drink',
};

const THINGS_TO_DO_HOBBIES_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[HOBBIES_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/c967da/django/images/things_to_do/ways-to-tour/hobbies.webp',
    key: HOBBIES_EVENTBRITE_CATEGORY,
    slug: 'hobbies',
};

const THINGS_TO_DO_HEALTH_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[HEALTH_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/b1a9c6/django/images/things_to_do/ways-to-tour/health.webp',
    key: HEALTH_EVENTBRITE_CATEGORY,
    slug: 'health',
};

const THINGS_TO_DO_TRAVEL_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[TRAVEL_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/789804/django/images/things_to_do/ways-to-tour/travel.webp',
    key: TRAVEL_EVENTBRITE_CATEGORY,
    slug: 'travel-and-outdoor',
};

const THINGS_TO_DO_FASHION_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[FASHION_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/a5cd1d/django/images/things_to_do/ways-to-tour/fashion.webp',
    key: FASHION_EVENTBRITE_CATEGORY,
    slug: 'fashion',
};

const THINGS_TO_DO_SCIENCE_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[SCIENCE_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/230037/django/images/things_to_do/ways-to-tour/science.webp',
    key: SCIENCE_EVENTBRITE_CATEGORY,
    slug: 'science-and-tech',
};

const THINGS_TO_DO_CHARITY_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[CHARITY_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/6f0d35/django/images/things_to_do/ways-to-tour/charity_and_causes.webp',
    key: CHARITY_EVENTBRITE_CATEGORY,
    slug: 'charity-and-causes',
};

const THINGS_TO_DO_POLITICS_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[POLITICS_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/d094c1/django/images/things_to_do/ways-to-tour/government.webp',
    key: POLITICS_EVENTBRITE_CATEGORY,
    slug: 'government',
};

const THINGS_TO_DO_COMMUNITY_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[COMMUNITY_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/7d78c8/django/images/things_to_do/ways-to-tour/community.webp',
    key: COMMUNITY_EVENTBRITE_CATEGORY,
    slug: 'community',
};

const THINGS_TO_DO_RELIGION_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[RELIGION_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/e8adc3/django/images/things_to_do/ways-to-tour/spirituality.webp',
    key: RELIGION_EVENTBRITE_CATEGORY,
    slug: 'spirituality',
};

const THINGS_TO_DO_FAMILY_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[
        FAMILY_EDUCATION_EVENTBRITE_CATEGORY
    ],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/6bcdbf/django/images/things_to_do/ways-to-tour/family.webp',
    key: FAMILY_EDUCATION_EVENTBRITE_CATEGORY,
    slug: 'family-and-education',
};

const THINGS_TO_DO_SEASONAL_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[SEASONAL_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/05e54e/django/images/things_to_do/ways-to-tour/holiday.webp',
    key: SEASONAL_EVENTBRITE_CATEGORY,
    slug: 'holiday',
};

const THINGS_TO_DO_HOME_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[
        HOME_LIFESTYLE_EVENTBRITE_CATEGORY
    ],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/b603ba/django/images/things_to_do/ways-to-tour/home.webp',
    key: HOME_LIFESTYLE_EVENTBRITE_CATEGORY,
    slug: 'home-and-lifestyle',
};

const THINGS_TO_DO_AUTO_BOAT_AIR_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[
        AUTO_BOAT_AIR_EVENTBRITE_CATEGORY
    ],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/b57655/django/images/things_to_do/ways-to-tour/auto.webp',
    key: AUTO_BOAT_AIR_EVENTBRITE_CATEGORY,
    slug: 'auto-boat-and-air',
};

const THINGS_TO_DO_SCHOOL_CONTENT = {
    title: EVENTBRITE_CATEGORY_DISPLAY_MAPPING[SCHOOL_EVENTBRITE_CATEGORY],
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/5b2fa6/django/images/things_to_do/ways-to-tour/school.webp',
    key: SCHOOL_EVENTBRITE_CATEGORY,
    slug: 'school-activities',
};

const THINGS_TO_DO_OTHER_CONTENT = {
    title: gettext('Eclectic'),
    imageUrl:
        'https://cdn.evbstatic.com/s3-build/perm_001/789804/django/images/things_to_do/ways-to-tour/travel.webp',
    key: OTHER_EVENTBRITE_CATEGORY,
    slug: 'other',
};

export const CATEGORY_CONTENT_MAP = {
    [MUSIC_EVENTBRITE_CATEGORY]: THINGS_TO_DO_MUSIC_CONTENT,
    [BUSINESS_EVENTBRITE_CATEGORY]: THINGS_TO_DO_BUSINESS_CONTENT,
    [PERFORMING_EVENTBRITE_CATEGORY]: THINGS_TO_DO_PERFORMING_CONTENT,
    [FILM_EVENTBRITE_CATEGORY]: THINGS_TO_DO_FILM_CONTENT,
    [SPORTS_EVENTBRITE_CATEGORY]: THINGS_TO_DO_SPORTS_CONTENT,
    [FOOD_AND_DRINK_EVENTBRITE_CATEGORY]: THINGS_TO_DO_FOOD_AND_DRINK_CONTENT,
    [HOBBIES_EVENTBRITE_CATEGORY]: THINGS_TO_DO_HOBBIES_CONTENT,
    [HEALTH_EVENTBRITE_CATEGORY]: THINGS_TO_DO_HEALTH_CONTENT,
    [TRAVEL_EVENTBRITE_CATEGORY]: THINGS_TO_DO_TRAVEL_CONTENT,
    [FASHION_EVENTBRITE_CATEGORY]: THINGS_TO_DO_FASHION_CONTENT,
    [SCIENCE_EVENTBRITE_CATEGORY]: THINGS_TO_DO_SCIENCE_CONTENT,
    [CHARITY_EVENTBRITE_CATEGORY]: THINGS_TO_DO_CHARITY_CONTENT,
    [POLITICS_EVENTBRITE_CATEGORY]: THINGS_TO_DO_POLITICS_CONTENT,
    [COMMUNITY_EVENTBRITE_CATEGORY]: THINGS_TO_DO_COMMUNITY_CONTENT,
    [RELIGION_EVENTBRITE_CATEGORY]: THINGS_TO_DO_RELIGION_CONTENT,
    [FAMILY_EDUCATION_EVENTBRITE_CATEGORY]: THINGS_TO_DO_FAMILY_CONTENT,
    [SEASONAL_EVENTBRITE_CATEGORY]: THINGS_TO_DO_SEASONAL_CONTENT,
    [HOME_LIFESTYLE_EVENTBRITE_CATEGORY]: THINGS_TO_DO_HOME_CONTENT,
    [AUTO_BOAT_AIR_EVENTBRITE_CATEGORY]: THINGS_TO_DO_AUTO_BOAT_AIR_CONTENT,
    [SCHOOL_EVENTBRITE_CATEGORY]: THINGS_TO_DO_SCHOOL_CONTENT,
    [OTHER_EVENTBRITE_CATEGORY]: THINGS_TO_DO_OTHER_CONTENT,
};
